import {Component, input, OnInit, signal} from '@angular/core';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {takeUntil} from 'rxjs';

@Component({
  selector: 'app-choice-base',
  imports: [],
  template: ''
})
export class StringFieldBaseComponent extends FieldBaseComponent<string | null> implements OnInit {

  public readonly maxLength = input.required<number>();
  public readonly charsLeft = signal(0);

  public ngOnInit(): void {
    super.ngOnInit();
    this.refreshCharsLeft();
    this.control.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(this.refreshCharsLeft.bind(this));
  }

  private refreshCharsLeft() {
    this.charsLeft.set(this.maxLength() - (this.control.value?.length ?? 0));
  }

}
